import { lazy } from "react";

const RELOADED = "wosool:chunk-reload";

const isChunkError = (error) =>
  error?.name === "ChunkLoadError" ||
  /Loading (CSS )?chunk [\w-]+ failed/.test(error?.message || "");

/**
 * `React.lazy` for a part of the app that is its own chunk. A deploy renames
 * every chunk, so a tab opened before it asks for files that no longer exist —
 * and the cure is the new index.html: the page reloads itself. Once: a chunk
 * that is missing for any other reason must not loop, so a second failure in
 * the same tab is thrown to the ErrorBoundary instead.
 */
export function lazyWithReload(load) {
  return lazy(() =>
    load().then(
      (module) => {
        try {
          sessionStorage.removeItem(RELOADED);
        } catch (e) {
          // storage unavailable: nothing to clear
        }
        return module;
      },
      (error) => {
        if (isChunkError(error)) {
          let reloadedAlready = false;
          try {
            reloadedAlready = sessionStorage.getItem(RELOADED) === "1";
            sessionStorage.setItem(RELOADED, "1");
          } catch (e) {
            reloadedAlready = true; // cannot remember a reload, so never risk a loop
          }
          if (!reloadedAlready) {
            window.location.reload();
            return new Promise(() => {}); // the reload takes over
          }
        }
        throw error;
      }
    )
  );
}
